export default "__VITE_ASSET__D1cZn1Y7__"